<template>
  <div class="flex items-center gap-2 rounded-ds-sm px-2 py-1.5 -mx-2 hover:bg-muted">
    <DSCheckbox
      :id="fieldId"
      :model-value="enabled"
      :disabled="readonly"
      class="ds-control"
      @update:model-value="enabled => $emit('toggle', !!enabled)"
    />
    <label
      :for="fieldId"
      class="min-w-0 flex-1 cursor-pointer truncate text-sm"
      :class="enabled ? 'font-semibold text-foreground' : 'font-medium text-muted-foreground'"
    >{{ caption }}</label>
    <GripVertical
      v-if="!readonly"
      class="size-3 shrink-0 cursor-grab text-muted-foreground/50 hover:text-muted-foreground"
      aria-hidden="true"
      data-handle="true"
    />
  </div>
</template>

<script setup lang="ts">
import { useId } from 'vue'
import { GripVertical } from '@lucide/vue'

import { DSCheckbox } from '@ds'

type Props = {
  caption: string
  enabled: boolean
  readonly?: boolean
}

type Emits = {
  'toggle': [enabled: boolean]
}

defineProps<Props>()
defineEmits<Emits>()

// Instance-unique — `caption` alone collides across widgets with the same field (e.g. two
// pivots on one dashboard both showing "Year") and toggles the wrong widget's checkbox.
const fieldId = useId()
</script>
